import React from 'react';

const SvgDot: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6 6" {...props}>
      <circle cx={3} cy={3} r={3} fill="#323650" />
    </svg>
  );
};

export default SvgDot;
